import script from "./Expense.vue?vue&type=script&setup=true&lang=js"
export * from "./Expense.vue?vue&type=script&setup=true&lang=js"

import "./Expense.vue?vue&type=style&index=0&id=0faf10c0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0faf10c0"]])

export default __exports__